import { Edit } from '@mui/icons-material';
import {
  orange,
  tableBodyGrey,
  tableHeaderGrey,
  white,
} from 'common/styles/colors';
import { boxShadow } from 'common/styles/page';
import styled from 'styled-components';
import { AddSettingForm, AddSettingInput } from '../../styles';

export const EditBtn = styled.button.attrs({ type: 'button' })`
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border-radius: 50%;
  border: none;
  border: 1px solid transparent;
  padding: 3px;
  color: ${tableHeaderGrey};

  &:hover {
    background: ${orange};
    border: 1px solid ${orange};
    color: white;
  }

  &:disabled {
    color: ${tableHeaderGrey};
    background: transparent;
    border: none;
    border: 1px solid transparent;
  }
`;

export const Icon = styled(Edit)`
  color: inherit;
  width: 10px;
  height: 10px;
  margin: 0;
`;

export const CodeInput = styled(AddSettingInput)`
  height: 30px;
  max-width: 100px;
`;

export const RootstockCodeInput = styled(AddSettingInput)`
  max-width: 150px;
`;

export const ModalFormWrapper = styled(AddSettingForm)`
  flex-direction: column;
  position: absolute;
  top: 30%;
  max-width: 350px;
  border: 1px solid ${orange};
`;

export const ModalPrompt = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: KanitLight;
  font-size: 16px;
  color: ${tableBodyGrey};
`;

export const VarOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 350px;
  border-radius: 4px;
  background: ${white};
  padding: 10px;
  margin: 0 10px;
  overflow-y: scroll;

  span {
    text-align: center;
  }

  // Ensure the scrollbar is always visible.
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${tableHeaderGrey};
    box-shadow: 0 0 1px ${boxShadow};
  }
`;

export const VarOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 5px 30px;
`;
